<template>
  <v-card>

    <!-- barra superior del asistente -->
    <v-card-title class="buttonBar">
      <div style='width:100% '>
        <div class="headline" style="float: left;">
          <v-btn icon @click="fSalirAsistente()" style="margin: 0px">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span>{{ asistentePresupuestotxt }} {{ numeroPresupuesto }}</span>
        </div>
      </div>
    </v-card-title>

    <!-- stepper del asistente -->
    <v-card-text>
      <v-stepper v-model="pasoActual" class="subheading stepperAsistente">
        <!-- cabecera del stepper -->
        <v-stepper-header>
          <v-stepper-step step="1" :complete="pasoActual > 1">{{ $t('empresaCliente') }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="pasoActual > 2">{{ $t('datosPresupuesto') }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :complete="pasoActual > 3">{{ $t('articulos') }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4">{{ $t('resumen') }}</v-stepper-step>
        </v-stepper-header>

        <!-- contenido(paginas) del stepper -->
        <v-stepper-items>
          <v-stepper-content step="1">
            <ShpAsistentePaso1 ref="Asistente1" @loading="fLoading" @alert="fAlert" @save="fSavePres"
              @return="fVolverPaso" @newId="fGetNewId" :pPresupuestoAsistente="presupuestoAsistente"
              :pEsNuevo="esNuevo">
            </ShpAsistentePaso1>
          </v-stepper-content>
          <v-stepper-content step="2">
            <ShpAsistentePaso2 ref="Asistente2" @loading="fLoading" @alert="fAlert" @save="fSavePres"
              @return="fVolverPaso" :pPresupuestoAsistente="presupuestoAsistente" :pEsNuevo="esNuevo">
            </ShpAsistentePaso2>
          </v-stepper-content>
          <v-stepper-content step="3">
            <ShpAsistentePaso3 ref="Asistente3" @loading="fLoading" @alert="fAlert" @save="fSavePres"
              @saveDet="fSavePresDet" @delete="fDeletePresDetEvent" @return="fVolverPaso"
              :pPresupuestoAsistente="presupuestoAsistente" :pEsNuevo="esNuevo">
            </ShpAsistentePaso3>
          </v-stepper-content>
          <v-stepper-content step="4">
            <ShpAsistentePaso4 ref="Asistente4" @loading="fLoading" @alert="fAlert" @save="fSavePres"
              @return="fVolverPaso" @goToListado="fEmitListado" :pPresupuestoAsistente="presupuestoAsistente">
            </ShpAsistentePaso4>
          </v-stepper-content>
        </v-stepper-items>

      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script>

import ShpAsistentePaso1 from './ShpAsistentePaso1'
import ShpAsistentePaso2 from './ShpAsistentePaso2'
import ShpAsistentePaso3 from './ShpAsistentePaso3'
import ShpAsistentePaso4 from './ShpAsistentePaso4'

// SERVICES
import SrvPres from '@/services/srv-presupuestos'

const ORIGEN_LISTADO = 'listado'
const ORIGEN_ASISTENTE = 'asistente'
const ORIGEN_RESUMEN = 'resumen'

export default {
  name: 'ShpAsistente',
  props: {
    origen: {
      type: String,
      required: true
    },
    presupuesto: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      pasoActual: 1,
      products: null,
      presupuestoAsistente: null,
      asistentePresupuestotxt: '',
      esNuevo: true,
      numeroPresupuesto: (this.presupuesto.numeroPedido) ? ' : ' + this.presupuesto.numeroPedido : this.presupuesto.numeroPedido
    }
  },
  components: {
    ShpAsistentePaso1,
    ShpAsistentePaso2,
    ShpAsistentePaso3,
    ShpAsistentePaso4
  },
  created() {
    // Comprueba si es un nuevo presupuesto o va a editarlo
    if (this.presupuesto.id === null) {
      this.esNuevo = true
      this.nuevoPresupuesto()
      this.asistentePresupuestotxt = this.$t('asistenteNuevoPresupuesto')
    } else {
      this.esNuevo = false
      this.asistentePresupuestotxt = this.$t('asistentePresupuesto')
      this.getPresupuesto()
    }
  },
  methods: {
    fSavePres(presupuesto) {
      if (typeof presupuesto.dtoPP === 'object') {
        presupuesto.dtoPP = presupuesto.dtoPP.tipoDescuento
      }
      if (typeof presupuesto.dtoRappel === 'object') {
        presupuesto.dtoRappel = presupuesto.dtoRappel.tipoDescuento
      }
      this.presupuestoAsistente = presupuesto
      this.pasoActual = this.pasoActual + 1
      this.fGuardaCabeceraPresupuesto()
    },
    fVolverPaso() {
      this.pasoActual = this.pasoActual - 1
    },
    fGetNewId(clienteId) {
      this.fGetNuevoNumeroPresupuesto(clienteId)
    },
    fSavePresDet(presupuesto) {
      this.presupuestoAsistente = presupuesto
      this.fGuardaDetallePresupuesto()
    },
    fDeletePresDetEvent(linea) {
      this.fDeleteDetPres(linea)
    },
    fEmitListado() {
      this.$emit('goToListado')
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    /**
     * Metodo para salir del asistente
     */
    fSalirAsistente() {
      if (this.origen === ORIGEN_RESUMEN) {
        this.$emit('goToResum', this.presupuesto, ORIGEN_ASISTENTE)
      }
      if (this.origen === ORIGEN_LISTADO) {
        this.fEmitListado()
      }
    },
    /**
     * Crea un objeto con toda la informacion que necesita para empezar vacia
     */
    nuevoPresupuesto() {
      const fechaCreacion = new Date()
      const fechaVigencia = new Date()
      fechaVigencia.setDate(fechaVigencia.getDate() + 7)
      // ver como obtener un nuevo numero de presupuesto o queda nulo para emprezar
      this.presupuestoAsistente = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        empresa: this.$store.getters.getAutenticacion.empresa,
        nombreEmpresa: this.$store.getters.getAutenticacion.nombreEmpresa,
        id: null,
        moneda: 'EUR',
        numeroPedido: null,
        cliente: null,
        sucursalEnvio: null,
        razonSocial: null,
        importePedidoEntrado: null,
        estado: null,
        nombreEstado: null,
        contabilidad: 0,
        tipo: '0',
        numeroBis: null,
        formaPago: null,
        tipoDtoRappel: null,
        tipoDtoPP: null,
        representante: null,
        agente: null,
        fechaCreacion: this.$moment(fechaCreacion, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        vigencia: this.$moment(fechaVigencia, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        plazoEntrega: null,
        refPedido: null,
        observaciones: null,
        lineas: []
      }
    },
    /**
     * Carga un presupuesto para editarlo
     */
    getPresupuesto() {
      // Incializa el presupuesto
      this.nuevoPresupuesto()
      this.$emit('loading', this.$t('iniCabPres'))
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        id: this.presupuesto.id
      }
      SrvPres.getPresCab(payload).then(response => {
        if (response.data.statusCode === '200') {
          const dataCabecera = response.data
          this.presupuestoAsistente = dataCabecera.cabeceraPresupuesto
          this.presupuestoAsistente.lineas = []
          this.$refs.Asistente1.fCargarDefault(this.presupuestoAsistente)
          this.getDetallePresupuesto()
        } else {
          this.$emit('alert', '<b>carga cabecera presupuesto</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
        this.$emit('loading', '')
      }).catch(error => {
        this.fErrorComprobado(error)
        this.$emit('loading', '')
      })
    },
    /**
     * Carga el detalle de un presupuesto para editarlo
     */
    getDetallePresupuesto() {
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: this.presupuestoAsistente.cliente,
        tipo: this.presupuestoAsistente.tipo,
        numeroPedido: this.presupuestoAsistente.numeroPedido,
        numeroBis: this.presupuestoAsistente.numeroBis
      }
      SrvPres.getDetallePresupuesto(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.presupuestoAsistente.lineas = response.data.detallePresupuesto
          this.lineas = this.presupuestoAsistente.lineas
          this.lineas.map((linea, index) => {
            if (linea.descuento !== 0) {
              const tempDescuento = linea.descuento.toFixed(2)
              linea.descuento = tempDescuento.replace('.', ',') + '%'
            } else {
              linea.descuento = '-'
            }
          })
          let directorio = ''
          const files = this.presupuestoAsistente.lineas.map((linea) => {
            const img = linea.imagen.split('/')[linea.imagen.split('/').length - 1]
            directorio = linea.imagen.replace(img, '').toLowerCase()
            return {
              name: img
            }
          })
          const payload = {
            items: files,
            directory: directorio,
            publicSN: 'N',
            contentType: 'BASE64'
          }
          SrvPres.cargarImagenes(payload).then(response => {
            if (response.data.statusCode === 200) {
              this.lineas.map((linea, index) => {
                if ((response.data.items[index].statusCode === undefined || response.data.items[index].statusCode === null)) {
                  linea.imagen = response.data.items[index].url + '&t=' + this.$store.getters.getAutenticacion.tira
                } else {
                  linea.imagen = 'https://astepahead.nl/getimage/products/jltfnt2-40.jpg;jltfnt2-40-front.jpg'
                }
              })
            } else {
              this.$emit('alert', '<b>carga imagenes</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
            }
          }).catch(error => {
            this.fErrorComprobado(error)
          })
          this.$refs.Asistente3.fCargarDefault(this.presupuestoAsistente)
        } else {
          this.$emit('alert', '<b>carga detalle presupuesto</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    },
    /**
     * Obtiene un nuevo id de presupuesto segun cliente
     */
    fGetNuevoNumeroPresupuesto(clienteId) {
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: clienteId,
        tipo: '0'
      }
      SrvPres.getNewIdPres(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.numeroPresupuesto = ' : ' + response.data.result[0].numeroPresupuesto
          this.presupuestoAsistente.numeroPedido = response.data.result[0].numeroPresupuesto
        } else {
          this.$emit('alert', '<b>obtiene numero presupuesto</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.fErrorComprobado(error)
      })
    },
    /**
     * Guarda un presupuesto
     */
    fGuardaCabeceraPresupuesto() {
      const idPedido = this.esNuevo ? '' : this.presupuestoAsistente.id
      let accionPedido = 'A'
      if (this.esNuevo) {
        accionPedido = 'I'
      }

      const tempFechaCreacion = (this.presupuestoAsistente.fechaCreacion !== null) ? this.presupuestoAsistente.fechaCreacion : ''
      const tempFechaVigencia = (this.presupuestoAsistente.vigencia !== null) ? this.presupuestoAsistente.vigencia : ''
      const tempPlazoEntrega = (this.presupuestoAsistente.plazoEntrega !== null && this.presupuestoAsistente.plazoEntrega !== '') ? this.presupuestoAsistente.plazoEntrega : ''
      this.$emit('loading', this.$t('saveCabPres'))
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        numero: this.presupuestoAsistente.numeroPedido,
        tipo: '0',
        cliente: this.presupuestoAsistente.cliente,
        sucursalEnvio: this.presupuestoAsistente.sucursalEnvio,
        id: idPedido,
        dtoRappel: this.presupuestoAsistente.dtoRappel,
        dtoPP: this.presupuestoAsistente.dtoPP,
        fecha: tempFechaCreacion,
        fechaVigencia: tempFechaVigencia,
        plazoEntrega: tempPlazoEntrega,
        formaPago: this.presupuestoAsistente.formaPago,
        refPedido: this.presupuestoAsistente.refPedido,
        observaciones: this.presupuestoAsistente.observaciones,
        accion: accionPedido
      }
      SrvPres.savePres(payload).then(response => {
        if (response.data.statusCode === '200') {
          if (this.esNuevo) {
            this.presupuestoAsistente.id = response.data.id
            this.presupuestoAsistente.numeroBis = response.data.numeroBis
            this.presupuestoAsistente.moneda = response.data.moneda
            this.presupuestoAsistente.plazoEntrega = response.data.plazoEntrega
            this.esNuevo = false
          }
          switch (this.pasoActual) {
            case 1:
              this.$refs.Asistente1.fCargarDefault(this.presupuestoAsistente)
              break
            case 2:
              this.$refs.Asistente2.fCargarDefault(this.presupuestoAsistente)
              break
            case 3:
              this.$refs.Asistente3.fCargarDefault(this.presupuestoAsistente)
              break
            case 4:
              this.$refs.Asistente4.fCargarDefault(this.presupuestoAsistente)
              break
          }
        } else {
          this.$emit('alert', '<b>guarda presupuesto</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
        this.$emit('loading', '')
      }).catch(error => {
        this.fErrorComprobado(error)
        this.$emit('loading', '')
      })
    },
    /**
     * Carga el detalle de un presupuesto para editarlo
     */
    fGuardaDetallePresupuesto() {
      const listaLineasPresupuestoTemp = this.presupuestoAsistente.lineas.map((linea) => {
        return {
          idCabecera: this.presupuestoAsistente.id,
          idLinea: linea.idLinea,
          numeroItem: linea.numeroItem,
          articulo: linea.articulo,
          cantidad: linea.cantidad,
          tarifa: linea.tarifa,
          precio: linea.precioArticulo,
          precioTarifa: linea.precioTarifa,
          fechaTarifa: linea.fechaTarifa,
          dto: linea.tipoDescuento,
          ref: linea.referencia,
          accion: linea.accion,
          recalcularPrecio: linea.precioModificado,
          ump: linea.ump,
          cantidadUmv: linea.cantidadUmv,
          umv: linea.umv,
          observaciones: linea.observaciones,
          estado: linea.estado,
          brutoNeto: linea.brutoNeto,
          agrupacion: linea.agrupacion
        }
      })
      this.$emit('loading', this.$emit('saveDetPres'))
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        listaLineasPresupuesto: listaLineasPresupuestoTemp
      }
      SrvPres.savePresDet(payload).then(response => {
        if (response.data.statusCode === '200') {
          if (response.data.errorCode === undefined) {
            this.getDetallePresupuesto()
          } else {
            this.$emit('alert', '<b>guarda detalle presupuesto</b><br> ' + response.data.errorMsg)
            this.$refs.Asistente3.fClose()
          }
        } else {
          this.$emit('alert', '<b>guarda detalle presupuesto</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
          this.$refs.Asistente3.fClose()
        }
        this.$emit('loading', '')
      }).catch(error => {
        this.fErrorComprobado(error)
        this.$emit('loading', '')
      })
    },
    fLoading(msg) {
      this.$emit('loading', msg)
    },
    /**
     * Carga el detalle de un presupuesto para editarlo
     */
    fDeleteDetPres(linea) {
      this.$emit('loading', this.$t('deleteItem'))
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: this.presupuestoAsistente.cliente,
        numeroPedido: this.presupuestoAsistente.numeroPedido,
        numeroBis: linea.numeroBis,
        numeroItem: linea.numeroItem
      }
      SrvPres.deletePresDet(payload).then(response => {
        if (response.data.statusCode === '200') {
          this.getDetallePresupuesto()
        } else {
          this.$emit('alert', '<b>borra detalle presupuesto</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
        this.$emit('loading', '')
      }).catch(error => {
        this.fErrorComprobado(error)
        this.$emit('loading', '')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.stepperAsistente .primary {
  background-color: #43a047 !important;
  border-color: #1b5e20 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpAsistente.vue